import type { EconomyConfig } from "./schema.ts";

const MAX_LEVEL = 100;

export function firstClearGold(economy: EconomyConfig, level: number): number {
  if (!Number.isInteger(level) || level < 1 || level > MAX_LEVEL) {
    throw new RangeError(`level must be an integer from 1 to ${MAX_LEVEL}`);
  }

  const extraTiers = Math.floor((level - 1) / 10);
  return economy.firstClearGold.base + extraTiers * economy.firstClearGold.perTenLevels;
}

export function firstThreeStarBonusGold(economy: EconomyConfig): number {
  return economy.firstThreeStarBonusGold;
}

export function replayGold(): 0 {
  return 0;
}
